module.exports = __webpack_public_path__ + "static/img/yx.png";